<template>
  <div>
    <v-container v-if="loadingPage" class="fill-height pa-0 align-start" fluid>
      <v-progress-linear indeterminate></v-progress-linear>
    </v-container>
    <v-container v-else :fluid="$vuetify.breakpoint.lgAndDown" class="px-8 py-2 white">
      <v-dialog v-model="dialogEmptyPostulantsImport" max-width="400">
        <v-card>
          <v-card-title class="headline error--text">
            Error
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogEmptyPostulantsImport = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>El archivo que desea importar esta vacío</v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-if="loadDialog"
        v-model="loadDialog"
        max-width="800px"
        @click:outside="closeFileDialog"
        scrollable
        fullscreen
      >
        <v-card :loading="loadingAddPostulant" :disabled="loadingAddPostulant">
          <v-card-title class="flex-nowrap">
            <span class="font-weight-bold title">{{ loadDocument.title }}</span>
            <v-spacer></v-spacer>
            <v-btn @click="closeFileDialog" icon>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <template v-if="loadingFile">
            <v-card-text>
              <v-progress-linear indeterminate></v-progress-linear>
            </v-card-text>
          </template>
          <template v-else>
            <!-- <v-card-text>Verifique la información antes de enviarla</v-card-text> -->
            <v-card-text v-if="postulantsBulk.length > 0" class="pa-0">
              <v-data-table :headers="fileHeaders" :items="postulantsBulk">
                <template v-slot:item.numero_documento="props">
                  <v-text-field
                    dense
                    :class="props.item.repeated ? 'font-weight-bold':''"
                    v-model="props.item.numero_documento"
                    single-line
                    hide-details
                  >
                    <template
                      v-slot:append
                      v-if="props.item.repeated || !props.item.numero_documento"
                    >
                      <v-icon color="error">mdi-alert-circle</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <template v-slot:item.tipo_documento="props">
                  <v-select
                    dense
                    :items="['Documento', 'Pasaporte']"
                    v-model="props.item.tipo_documento"
                    single-line
                    hide-details
                  >
                    <template v-slot:append v-if="!props.item.tipo_documento">
                      <v-icon color="error">mdi-alert-circle</v-icon>
                    </template>
                  </v-select>
                </template>
                <template v-slot:item.nombres="props">
                  <v-text-field dense v-model="props.item.nombres" single-line hide-details>
                    <template v-slot:append v-if="!props.item.nombres">
                      <v-icon color="error">mdi-alert-circle</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <template v-slot:item.apellidos="props">
                  <v-text-field dense v-model="props.item.apellidos" single-line hide-details>
                    <template v-slot:append v-if="!props.item.apellidos">
                      <v-icon color="error">mdi-alert-circle</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <template v-slot:item.correo="props">
                  <v-text-field dense v-model="props.item.correo" single-line hide-details>
                    <template v-slot:append v-if="!props.item.correo">
                      <v-icon color="error">mdi-alert-circle</v-icon>
                    </template>
                  </v-text-field>
                </template>
              </v-data-table>
            </v-card-text>
          </template>
          <v-divider></v-divider>
          <v-card-actions>
            <v-container fluid>
              <v-row>
                <v-col class="py-0 d-flex flex-wrap">
                  <span class="body-2 grey--text text--darken-1 d-flex align-center mb-2">
                    El icono
                    <v-icon color="error" class="mx-2">mdi-alert-circle</v-icon>indica los campos con valores erroneos
                  </span>
                  <v-spacer></v-spacer>
                  <div class="d-flex">
                    <BaseMyButton color="error" @click="closeFileDialog">Cancelar</BaseMyButton>
                    <BaseMyButton
                      color="success"
                      class="ml-2"
                      :disabled="!postulantsBulkValid"
                      @click="addPostulantsBulk"
                    >Agregar</BaseMyButton>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialog"
        @click:outside="closeDialog"
        max-width="600px"
        :fullscreen="!$vuetify.breakpoint.mdAndUp"
      >
        <v-card>
          <v-card-title>
            <span class="font-weight-bold title">Agregar postulante</span>
            <v-spacer></v-spacer>
            <v-btn @click="closeDialog" icon>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-4">
            <v-container>
              <v-row>
                <v-col cols="12" md="6" class="py-2">
                  <BaseMySelect
                    v-model="postulant.tipo_documento"
                    :items="documentTypes"
                    label="Tipo de documento *"
                    :error-messages="tipoDocumentoErrors"
                    @input="$v.postulant.tipo_documento.$touch()"
                    @blur="$v.postulant.tipo_documento.$touch()"
                    required
                  ></BaseMySelect>
                </v-col>
                <v-col cols="12" md="6" class="py-2">
                  <BaseMyTextField
                    v-model="postulant.numero_documento"
                    :error-messages="numeroDocumentoErrors"
                    label="Número de documento *"
                    required
                    counter
                    @input="$v.postulant.numero_documento.$touch()"
                    @blur="$v.postulant.numero_documento.$touch()"
                  ></BaseMyTextField>
                </v-col>
                <v-col cols="12" md="6" class="py-2">
                  <BaseMyTextField
                    v-model="postulant.nombres"
                    :error-messages="nombresErrors"
                    label="Nombres *"
                    required
                    @input="$v.postulant.nombres.$touch()"
                    @blur="$v.postulant.nombres.$touch()"
                  ></BaseMyTextField>
                </v-col>
                <v-col cols="12" md="6" class="py-2">
                  <BaseMyTextField
                    v-model="postulant.apellidos"
                    :error-messages="apellidosErrors"
                    label="Apellidos *"
                    required
                    @input="$v.postulant.apellidos.$touch()"
                    @blur="$v.postulant.apellidos.$touch()"
                  ></BaseMyTextField>
                </v-col>
                <v-col cols="12" class="py-2">
                  <BaseMyTextField
                    v-model="postulant.correo"
                    :error-messages="emailErrors"
                    label="Correo *"
                    required
                    @input="$v.postulant.correo.$touch()"
                    @blur="$v.postulant.correo.$touch()"
                  ></BaseMyTextField>
                </v-col>
              </v-row>
              <v-row></v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-container>
              <v-row>
                <v-col class="py-0 d-flex flex-wrap">
                  <span class="body-2 grey--text text--darken-1 mb-2">
                    <span class="font-weight-bold">*</span>
                    Indica los campos obligatorios
                  </span>
                  <v-spacer></v-spacer>
                  <div class="d-flex">
                    <BaseMyButton color="error" @click="closeDialog">Cancelar</BaseMyButton>
                    <BaseMyButton
                      color="success"
                      class="ml-2"
                      @click="addPostulant"
                      :disabled="$v.postulant.$invalid"
                    >Agregar</BaseMyButton>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogWithoutConfirm"
        max-width="680px"
        :fullscreen="!$vuetify.breakpoint.mdAndUp"
      >
        <v-card
          v-if="postulantWitoutConfirmSelected"
          :loading="loadingPostulantWitoutConfirm"
          :disabled="loadingPostulantWitoutConfirm"
        >
          <v-card-title>
            <span class="font-weight-bold title">Postulante sin confirmar</span>
            <v-spacer></v-spacer>
            <v-btn @click="dialogWithoutConfirm = false" icon>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-4">
            <v-container>
              <v-row>
                <v-col cols="12" md="6" class="py-2">
                  <BaseMySelect
                    v-model="postulantWitoutConfirmSelected.tipo_documento"
                    :items="documentTypes"
                    label="Tipo de documento *"
                    :error-messages="tipoDocumentoWithoutConfirmErrors"
                    @input="$v.postulantWitoutConfirmSelected.tipo_documento.$touch()"
                    @blur="$v.postulantWitoutConfirmSelected.tipo_documento.$touch()"
                    required
                  ></BaseMySelect>
                </v-col>
                <v-col cols="12" md="6" class="py-2">
                  <BaseMyTextField
                    v-model="postulantWitoutConfirmSelected.numero_documento"
                    :error-messages="numeroDocumentoWithoutConfirmErrors"
                    label="Número de documento *"
                    required
                    counter
                    @input="$v.postulantWitoutConfirmSelected.numero_documento.$touch()"
                    @blur="$v.postulantWitoutConfirmSelected.numero_documento.$touch()"
                  ></BaseMyTextField>
                </v-col>
                <v-col cols="12" md="6" class="py-2">
                  <BaseMyTextField
                    v-model="postulantWitoutConfirmSelected.nombres"
                    :error-messages="nombresWithoutConfirmErrors"
                    label="Nombres *"
                    required
                    @input="$v.postulantWitoutConfirmSelected.nombres.$touch()"
                    @blur="$v.postulantWitoutConfirmSelected.nombres.$touch()"
                  ></BaseMyTextField>
                </v-col>
                <v-col cols="12" md="6" class="py-2">
                  <BaseMyTextField
                    v-model="postulantWitoutConfirmSelected.apellidos"
                    :error-messages="apellidosWithoutConfirmErrors"
                    label="Apellidos *"
                    required
                    @input="$v.postulantWitoutConfirmSelected.apellidos.$touch()"
                    @blur="$v.postulantWitoutConfirmSelected.apellidos.$touch()"
                  ></BaseMyTextField>
                </v-col>
                <v-col cols="12" md="7" class="py-2">
                  <BaseMyTextField
                    v-model="postulantWitoutConfirmSelected.correo"
                    :error-messages="emailWithoutConfirmErrors"
                    label="Correo *"
                    required
                    @input="$v.postulantWitoutConfirmSelected.correo.$touch()"
                    @blur="$v.postulantWitoutConfirmSelected.correo.$touch()"
                  ></BaseMyTextField>
                </v-col>
                <v-col cols="12" md="5" class="py-2">
                  <BaseMyTextField
                    v-model="postulantWitoutConfirmSelected.telefono"
                    :error-messages="telefonoWithoutConfirmErrors"
                    label="Teléfono *"
                    required
                    @input="$v.postulantWitoutConfirmSelected.telefono.$touch()"
                    @blur="$v.postulantWitoutConfirmSelected.telefono.$touch()"
                  ></BaseMyTextField>
                </v-col>
              </v-row>
              <v-row></v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-container>
              <v-row>
                <v-col class="py-0 d-flex flex-wrap">
                  <span class="body-2 grey--text text--darken-1 mb-2">
                    <span class="font-weight-bold">*</span>
                    Indica los campos obligatorios
                  </span>
                  <v-spacer></v-spacer>
                  <div class="d-flex">
                    <BaseMyButton
                      color="error"
                      @click="dialogWithoutConfirm = false; $v.postulantWitoutConfirmSelected.$reset()"
                    >Cancelar</BaseMyButton>
                    <BaseMyButton
                      color="info"
                      class="ml-2"
                      @click="confirmPostulant"
                      :disabled="$v.postulantWitoutConfirmSelected.$invalid"
                    >Confirmar postulante</BaseMyButton>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-tabs v-model="tab" color="primary" grow class="mb-2" icons-and-text show-arrows>
        <v-tab class="font-weight-bold">
          <span v-if="$vuetify.breakpoint.mdAndUp">Postulantes confirmados</span>
          <v-icon class="mr-2">mdi-account-check</v-icon>
        </v-tab>
        <v-tab class="font-weight-bold">
          <span v-if="$vuetify.breakpoint.mdAndUp">Postulantes sin confirmar</span>
          <v-icon class="mr-2">mdi-account-clock</v-icon>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-row>
            <v-col class="d-flex pb-0 flex-wrap">
              <p class="display-2 font-weight-bold mr-8">Confirmados</p>
              <v-spacer></v-spacer>
              <input
                class="d-none"
                type="file"
                id="input-file-postulants"
                ref="input-file-postulants"
                @change="selectedFileAddPostulants"
              />
              <div>
                <BaseMyButton @click.stop="dialog = true" color="success">
                  <v-icon class="mr-2">mdi-plus</v-icon>Nuevo postulante
                </BaseMyButton>
                <v-menu open-on-hover offset-y left>
                  <template v-slot:activator="{ on: menu }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltip }">
                        <BaseMyButton
                          v-on="{ ...tooltip, ...menu }"
                          class="ml-2"
                          color="error"
                          @click="$refs['input-file-postulants'].value = null;
                            $refs['input-file-postulants'].click();"
                        >
                          <v-icon class="mr-2">mdi-file-import</v-icon>Importar
                        </BaseMyButton>
                      </template>
                      <span>Importar postulantes (xlsx)</span>
                    </v-tooltip>
                  </template>
                  <v-list>
                    <v-list-item @click="downloadTemplate()">
                      <v-list-item-icon>
                        <v-icon>mdi-download</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Descargar plantilla</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                placeholder="Buscar postulante"
                filled
                dense
                hide-details
                rounded
                class="mb-3"
              ></v-text-field>
              <v-card flat>
                <v-data-table
                  :headers="headers"
                  :items="postulants"
                  :search="search"
                  class="transparent"
                  style="cursor: pointer"
                  @click:row="selectePostulant"
                >
                  <template v-slot:item.createdAt="{ item }">{{ getDateFormat(item.createdAt) }}</template>
                  <template v-slot:item.progreso="{ item }">
                    <v-progress-linear
                      :color="`${colorPercentage(item.progreso)} lighten-5`"
                      :value="item.progreso"
                      height="25"
                      style="min-width: 150px"
                      :class="`${colorPercentage(item.progreso)}--text`"
                    >
                      <span class="font-weight-bold">{{ item.progreso }}%</span>
                    </v-progress-linear>
                    <!-- <v-progress-circular size="40" :value="percentageCurriculum(item.puntaje_maximo, item.puntaje)">
                      {{ percentageCurriculum(item.puntaje_maximo, item.puntaje) }}
                    </v-progress-circular>-->
                  </template>
                  <template v-slot:item.print="{ item }">
                    <v-btn
                      class="ml-2"
                      icon
                      target="_blank"
                      @click.stop="() => {}"
                      :to="{ name: 'administrator notices print curriculum applicant', params: { postulante: item._id } }"
                    >
                      <v-icon>mdi-printer</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <v-row>
            <v-col class="d-flex pb-0 flex-wrap">
              <p class="display-2 font-weight-bold mr-8">Sin confirmar</p>
              <v-spacer></v-spacer>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="searchWihoutConfirm"
                append-icon="mdi-magnify"
                placeholder="Buscar"
                filled
                dense
                hide-details
                rounded
                class="mb-3"
              ></v-text-field>
              <v-card flat :loading="loading" :disabled="loading">
                <v-data-table
                  :headers="headersWithoutConfirm"
                  :items="postulantsWithoutConfirm"
                  :search="searchWihoutConfirm"
                  class="transparent"
                  style="cursor: pointer"
                  @click:row="selectedPostulanWithoutConfirm"
                >
                  <template v-slot:item.createdAt="{ item }">{{ getDateFormat(item.createdAt) }}</template>
                  <template v-slot:item.delete="{ item }">
                    <v-btn @click.stop="deletePostulantWithoutConfirm(item._id)" icon color="error">
                      <v-icon>mdi-trash-can</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </div>
</template>

<script>
import store from "@/store";
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import { mapState } from "vuex";

import XLSX from "xlsx";

export default {
  name: "AdminPostulants",
  mixins: [validationMixin],

  validations: {
    postulant: {
      tipo_documento: { required },
      numero_documento: { required },
      nombres: { required },
      apellidos: { required },
      correo: { required, email }
    },
    postulantWitoutConfirmSelected: {
      tipo_documento: { required },
      numero_documento: { required },
      nombres: { required },
      apellidos: { required },
      correo: { required, email },
      telefono: { required }
    }
  },

  created() {
    this.getPageEvents();
    this.getPostulantsWitoutConfirm();
  },

  data() {
    return {
      tab: 0,
      dialogEmptyPostulantsImport: false,
      loadingPage: false,
      loadingPostulantWitoutConfirm: false,
      loading: false,
      loadDialog: false,
      loadingAddPostulant: false,
      show: false,
      dialog: false,
      dialogWithoutConfirm: false,
      postulantWitoutConfirmSelected: {
        tipo_documento: "",
        nombres: "",
        apellidos: "",
        correo: "",
        numero_documento: "",
        telefono: ""
      },
      postulantsBulk: [],
      loadDocument: {
        title: "",
        error: ""
      },
      loadingFile: false,
      postulant: {
        tipo_documento: "",
        nombres: "",
        apellidos: "",
        correo: "",
        numero_documento: ""
      },
      postulantDefault: {
        tipo_documento: "",
        nombres: "",
        apellidos: "",
        correo: "",
        numero_documento: ""
      },
      search: "",
      searchWihoutConfirm: "",
      headers: [
        {
          text: "Nombres",
          align: "start",
          value: "informacion_personal.nombres",
          class: "grey lighten-5"
        },
        {
          text: "Apellidos",
          value: "informacion_personal.apellidos",
          class: "grey lighten-5"
        },
        {
          text: "# Postulaciones",
          align: "center",
          value: "postulaciones",
          class: "grey lighten-5"
        },
        {
          text: "Documento",
          value: "informacion_personal.numero_documento",
          class: "grey lighten-5",
          sortable: false
        },
        {
          text: "Tipo Documento",
          value: "informacion_personal.tipo_documento",
          class: "grey lighten-5"
        },
        { text: "Correo", value: "correo", class: "grey lighten-5" },
        {
          text: "Fecha de creación",
          value: "createdAt",
          class: "grey lighten-5",
          align: "center"
        },
        {
          text: "HV Progreso",
          value: "progreso",
          class: "grey lighten-5",
          align: "center"
        },
        {
          text: "Print",
          value: "print",
          class: "grey lighten-5",
          align: "center",
          sortable: false,
          filtable: false,
        }
      ],
      headersWithoutConfirm: [
        {
          text: "Nombres",
          align: "start",
          value: "nombres",
          class: "grey lighten-5"
        },
        { text: "Apellidos", value: "apellidos", class: "grey lighten-5" },
        { text: "Correo", value: "correo", class: "grey lighten-5" },
        {
          text: "Teléfono",
          value: "telefono",
          class: "grey lighten-5"
        },
        {
          text: "Fecha de creación",
          value: "createdAt",
          class: "grey lighten-5",
          align: "center"
        },
        {
          text: "",
          value: "delete",
          class: "grey lighten-5",
          align: "center",
          sortable: false
        }
      ],
      documentTypes: ["Documento", "Pasaporte"],

      fileHeaders: [
        {
          text: "Número de documento",
          value: "numero_documento",
          class: "grey lighten-5"
        },
        {
          text: "Tipo de documento",
          value: "tipo_documento",
          class: "grey lighten-5"
        },
        { text: "Nombres", value: "nombres", class: "grey lighten-5" },
        { text: "Apellidos", value: "apellidos", class: "grey lighten-5" },
        { text: "Correo", value: "correo", class: "grey lighten-5" }
      ],
      postulantsWithoutConfirm: []
    };
  },
  computed: {
    ...mapState("administration/postulants", ["postulants"]),
    postulantsBulkValid() {
      const comparator = [];
      let isValid = true;
      this.postulantsBulk.forEach(postulantBulk => {
        const repeated = comparator
          .map(postulant => postulant.numero_documento)
          .indexOf(postulantBulk.numero_documento);

        if (repeated !== -1) {
          this.postulantsBulk[repeated].repeated = true;
          postulantBulk.repeated = true;
          isValid = false;
        } else {
          delete postulantBulk.repeated;
        }
        comparator.push(postulantBulk);
      });
      return isValid;
    },
    tipoDocumentoErrors() {
      const errors = [];
      if (!this.$v.postulant.tipo_documento.$dirty) return errors;
      !this.$v.postulant.tipo_documento.required &&
        errors.push("Por favor seleccione un tipo");
      return errors;
    },
    numeroDocumentoErrors() {
      const errors = [];
      if (!this.$v.postulant.numero_documento.$dirty) return errors;
      !this.$v.postulant.numero_documento.required &&
        errors.push("Por favor ingrese el número");
      return errors;
    },
    nombresErrors() {
      const errors = [];
      if (!this.$v.postulant.nombres.$dirty) return errors;
      !this.$v.postulant.nombres.required &&
        errors.push("Por favor ingrese Nombre");
      return errors;
    },
    apellidosErrors() {
      const errors = [];
      if (!this.$v.postulant.apellidos.$dirty) return errors;
      !this.$v.postulant.apellidos.required &&
        errors.push("Por favor ingrese Apellido");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.postulant.correo.$dirty) return errors;
      !this.$v.postulant.correo.email &&
        errors.push("Ingrese un correo válido");
      !this.$v.postulant.correo.required &&
        errors.push("Por favor ingrese Correo");
      return errors;
    },

    tipoDocumentoWithoutConfirmErrors() {
      const errors = [];
      if (!this.$v.postulantWitoutConfirmSelected.tipo_documento.$dirty)
        return errors;
      !this.$v.postulantWitoutConfirmSelected.tipo_documento.required &&
        errors.push("Por favor seleccione un tipo");
      return errors;
    },
    numeroDocumentoWithoutConfirmErrors() {
      const errors = [];
      if (!this.$v.postulantWitoutConfirmSelected.numero_documento.$dirty)
        return errors;
      !this.$v.postulantWitoutConfirmSelected.numero_documento.required &&
        errors.push("Por favor ingrese el número");
      return errors;
    },
    nombresWithoutConfirmErrors() {
      const errors = [];
      if (!this.$v.postulantWitoutConfirmSelected.nombres.$dirty) return errors;
      !this.$v.postulantWitoutConfirmSelected.nombres.required &&
        errors.push("Por favor ingrese Nombre");
      return errors;
    },
    apellidosWithoutConfirmErrors() {
      const errors = [];
      if (!this.$v.postulantWitoutConfirmSelected.apellidos.$dirty)
        return errors;
      !this.$v.postulantWitoutConfirmSelected.apellidos.required &&
        errors.push("Por favor ingrese Apellido");
      return errors;
    },
    emailWithoutConfirmErrors() {
      const errors = [];
      if (!this.$v.postulantWitoutConfirmSelected.correo.$dirty) return errors;
      !this.$v.postulantWitoutConfirmSelected.correo.email &&
        errors.push("Ingrese un correo válido");
      !this.$v.postulantWitoutConfirmSelected.correo.required &&
        errors.push("Por favor ingrese Correo");
      return errors;
    },
    telefonoWithoutConfirmErrors() {
      const errors = [];
      if (!this.$v.postulantWitoutConfirmSelected.telefono.$dirty)
        return errors;
      !this.$v.postulantWitoutConfirmSelected.telefono.required &&
        errors.push("Por favor ingrese Apellido");
      return errors;
    }
  },
  methods: {
    selectePostulant(postulant) {
      this.$router.push({ name: 'administrator postulants by id', params: { postulante: postulant._id } });
    },
    selectedPostulanWithoutConfirm(item) {
      this.dialogWithoutConfirm = true;

      this.postulantWitoutConfirmSelected = {
        tipo_documento: item.tipo_documento,
        nombres: item.nombres,
        apellidos: item.apellidos,
        correo: item.correo,
        numero_documento: item.numero_documento,
        telefono: item.telefono
      };
    },
    getPageEvents() {
      this.loadingPage = true;
      store
        .dispatch("administration/postulants/retrievePostulants")
        .then(() => {})
        .finally(() => {
          this.loadingPage = false;
        });
    },
    getPostulantsWitoutConfirm() {
      store
        .dispatch("administration/postulants/retrievePostulantsWitoutConfirm")
        .then(data => {
          this.postulantsWithoutConfirm = data;
        })
        .finally(() => {
          this.loadingPage = false;
        });
    },
    addPostulant() {
      this.loading = true;
      store
        .dispatch("administration/postulants/addPostulant", this.postulant)
        .then(() => {
          this.closeDialog();
          this.$store.commit("SET_ALERT", {
            color: "green",
            text: "Postulante agregado",
            visible: true
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    confirmPostulant() {
      this.loadingPostulantWitoutConfirm = true;

      const data = {
        tipo_documento: this.postulantWitoutConfirmSelected.tipo_documento,
        nombres: this.postulantWitoutConfirmSelected.nombres,
        apellidos: this.postulantWitoutConfirmSelected.apellidos,
        correo: this.postulantWitoutConfirmSelected.correo,
        numero_documento: this.postulantWitoutConfirmSelected.numero_documento
      };
      store
        .dispatch("administration/postulants/addPostulant", data)
        .then(() => {
          this.dialogWithoutConfirm = false;
          this.getPageEvents();
          this.getPostulantsWitoutConfirm();
          this.$store.commit("SET_ALERT", {
            color: "green",
            text: "Postulante confirmado",
            visible: true
          });
        })
        .finally(() => {
          this.loadingPostulantWitoutConfirm = false;
        });
    },
    deletePostulantWithoutConfirm(id) {
      this.loading = true;
      store
        .dispatch("administration/postulants/deletePostulantWithoutConfirm", id)
        .then(() => {
          this.getPostulantsWitoutConfirm();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addPostulantsBulk() {
      this.loadingAddPostulant = true;
      store
        .dispatch(
          "administration/postulants/addPostulantsBulk",
          this.postulantsBulk
        )
        .then(() => {
          this.loadDialog = false;
        })
        .finally(() => {
          this.loadingAddPostulant = false;
        });
    },
    selectedFileAddPostulants(event) {
      this.loadDocument.title = "Cargando archivo";
      this.loadingFile = true;
      const { files } = event.target;
      const f = files[0];
      const reader = new FileReader();
      reader.onload = e => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        /* DO SOMETHING WITH workbook HERE */
        const worksheet = workbook.Sheets[sheetName];
        const importedPostulants = XLSX.utils.sheet_to_json(worksheet);
        if (!importedPostulants.length) {
          this.dialogEmptyPostulantsImport = true;
          return;
        }
        this.loadDialog = true;
        importedPostulants.forEach(postulantOrigin => {
          const repeated = this.postulantsBulk
            .map(postulant => postulant.numero_documento)
            .indexOf(postulantOrigin.numero_documento);
          if (repeated !== -1) {
            postulantOrigin.repeated = true;
            this.postulantsBulk[repeated].repeated = true;
          }
          this.postulantsBulk.push(postulantOrigin);
        });
      };
      this.loadDocument.title = "Verifique la información de los postulantes";
      this.loadingFile = false;
      reader.readAsArrayBuffer(f);
    },
    getDateFormat(date) {
      return this.$moment(date).format("DD/MM/YYYY");
    },
    closeFileDialog() {
      const loadDocumentDefault = {
        title: "",
        error: ""
      };
      this.loadDocument = JSON.parse(JSON.stringify(loadDocumentDefault));
      this.loadDialog = false;
      this.postulantsBulk = [];
    },
    closeDialog() {
      this.$v.$reset();
      this.dialog = false;
      this.postulant = JSON.parse(JSON.stringify(this.postulantDefault));
    },
    colorPercentage(percentage) {
      let color = "grey";
      if (percentage <= 25) color = "error";
      else if (percentage > 25 && percentage <= 50) color = "warning";
      else if (percentage > 50 && percentage <= 75) color = "info";
      else if (percentage > 75) color = "success";
      return color;
    },
    downloadTemplate() {
      const nameTemplate = "Plantilla de postulantes";
      const wb = XLSX.utils.book_new();
      const wsData = [
        ["tipo_documento", "numero_documento", "nombres", "apellidos", "correo"]
      ];
      const ws = XLSX.utils.aoa_to_sheet(wsData);
      XLSX.utils.book_append_sheet(wb, ws, nameTemplate);
      XLSX.writeFile(wb, `${nameTemplate} Template.xlsx`, { cellStyles: true });
    }
  }
};
</script>